<router-outlet></router-outlet>
<div class="loading-container" *ngIf="loading$ | async">
  <nz-spin></nz-spin>
</div>
